import image0 from "./Speaker.jpg";

export default [
    image0
];
